import React from 'react'
import Popup from 'react-popup'
import { connect } from 'react-redux'
import intl from 'react-intl-universal'
import ShippingOrder from './ShippingOrder'

const mapStateToProps = state => ({
  order: state.pack.order
})

class ShippingListComponent extends React.Component {

    getShippingRow = (shipping) => {
      const { deleteShipping, generateReturnWaybill, show_generate_return_waybill } = this.props
      return (
        <tr data-id={shipping.id}
            key={shipping.id}
            onClick={this.select}>
          <td>{shipping.date}</td>
          <td>{shipping.carrier}</td>
          <td>{shipping.receiver_name}</td>
          <td>
            <button
              className="secondary delete_shipping"
              onClick={(e) => {
                e.stopPropagation()
                deleteShipping(shipping.id)
              }}
            ></button>
          </td>
          {show_generate_return_waybill &&
            <td>
              <button
                className="secondary generate_return_waybill"
                onClick={(e) => {
                  e.stopPropagation()
                  generateReturnWaybill(shipping.id)
                }}
              ></button>
            </td>
          }
        </tr>
      )
    }

    select = (e) => {
      const { parent } = this.props
      const value = e.currentTarget.dataset.id
      Popup.close()
      Popup.plugins().shippingOrder(value, parent)
    }

    render() {
      const { shipping_order_ids } = this.props.order
      return (
        <div className='table-wrapper'>
          <table className='table shipping_list'>
            <thead>
              <tr>
                <th>{ intl.get('Data listu przewozowego') }</th>
                <th>{ intl.get('Metoda dostawy') }</th>
                <th>{ intl.get('Odbiorca') }</th>
                <th></th>
                {this.props.show_generate_return_waybill &&
                  <th></th>
                }
              </tr>
            </thead>
            <tbody>
              {shipping_order_ids.map(shipping => this.getShippingRow(shipping))}
            </tbody>
          </table>
        </div>
      )
    }
}

const ShippingList = connect(mapStateToProps)(ShippingListComponent)

Popup.registerPlugin('shipping', function (new_action, deleteShipping, generateReturnWaybill, show_generate_return_waybill, parent) {

    this.create({
        title: intl.get('Przesyłki'),
        content: <ShippingList parent={parent} deleteShipping={deleteShipping} generateReturnWaybill={generateReturnWaybill} show_generate_return_waybill={show_generate_return_waybill} />,
        buttons: {
          right: [
            {
              text: intl.get('Dodaj przesyłkę'),
              action: function () {
                new_action()
                Popup.close()
                Popup.plugins().shippingOrder(0, parent)
              }
            },
            {
              text: intl.get('Anuluj'),
              className: 'cancel-button',
              action: function () {
                Popup.close()
              }
            }
          ]
        }
    })
})

